import { ArrowRight } from "lucide-react";
import { SectionLink } from "./SectionLink";
import { LEGAL_NAME, TAGLINE, DESCRIPTOR } from "./data";

const FACTS = [
  { label: "JMS", value: LEGAL_NAME },
  { label: "What we do", value: DESCRIPTOR },
  { label: "Where", value: "Chatham-Kent and surrounding areas" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-brand-navy py-20 text-white lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1.15fr_1fr] lg:gap-20">
      <div>
        <p className="eyebrow eyebrow-light">About JMS</p>
        <h2 className="mt-4 font-heading text-[1.75rem] font-semibold leading-tight tracking-tight sm:text-4xl" data-testid="about-heading">
          Modern technology. One local partner.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-white/75 md:text-lg">
          JMS Technologies provides practical, connected business technology, from everyday IT support and cloud services to physical installations, phones, security cameras and advertisement TVs.
        </p>
        <p className="mt-4 text-base leading-relaxed text-white/75">
          Our approach is simple: explain technology clearly, deliver it professionally, and keep supporting it after installation.
        </p>
        <SectionLink hash="#contact" data-testid="about-contact-button" className="btn-secondary-light mt-9">
          Contact JMS <ArrowRight className="h-4 w-4" />
        </SectionLink>
      </div>
      <div className="rounded-2xl border border-white/10 bg-brand-deep p-7 sm:p-9" data-testid="about-facts">
        <p className="font-heading text-2xl font-semibold text-white" data-testid="about-tagline">{TAGLINE}</p>
        <dl className="mt-8 divide-y divide-white/10">
          {FACTS.map((f) => (
            <div key={f.label} className="flex flex-col gap-1 py-4 sm:flex-row sm:justify-between sm:gap-6">
              <dt className="font-heading text-xs font-semibold uppercase tracking-[0.16em] text-brand-cyan">{f.label}</dt>
              <dd className="text-sm text-white/85 sm:text-right" data-testid={`about-fact-${f.label.toLowerCase().replace(/\s+/g, "-")}`}>{f.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </section>
);
